var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _circle2, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _circle3, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _circle4, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _circle5, _path167, _path168, _path169, _path170, _path171, _g2, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _circle6, _path200, _path201, _path202, _path203, _path204, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSystem1000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 761,
    height: 499,
    viewBox: "0 0 761 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445 43V499",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M306 43V499",
    stroke: "black",
    strokeOpacity: 0.38,
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145 43V499",
    stroke: "black",
    strokeOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75 144H328V150H75V144Z",
    fill: "black",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_24288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9835 138.758H60.8205C57.8205 138.758 53.1895 142.359 53.1895 146.802C53.1895 151.245 57.8205 154.846 60.8205 154.846H65.9835C68.6815 154.846 71.2915 153.42 73.3425 150.824V142.78C71.2915 140.184 68.6815 138.758 65.9835 138.758Z",
    fill: "url(#paint0_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0613 154.001H69.2603C68.4853 153.783 66.6003 154.335 66.5603 156.702C66.2223 176.615 64.6153 176.953 63.8603 176.953C63.1853 176.953 62.5103 176.277 62.8473 174.928C63.2133 173.464 64.1973 162.102 63.8603 158.052C63.7223 156.4 63.0523 155.467 62.2803 154.995L62.3633 155.002C62.9033 154.807 63.6373 153.413 63.7353 153.162H66.8203",
    fill: "url(#paint1_linear_59_24288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1739 153.986V154.189C69.2689 154.189 69.3509 154.123 69.3719 154.03C69.3929 153.937 69.3459 153.843 69.2599 153.803L69.1739 153.986ZM63.5719 158.053C63.7389 160.06 63.5789 163.898 63.3289 167.43C63.2039 169.193 63.0579 170.875 62.9199 172.207C62.7809 173.546 62.6519 174.515 62.5649 174.864L62.9579 174.962C63.0539 174.579 63.1849 173.578 63.3229 172.249C63.4619 170.912 63.6089 169.226 63.7339 167.459C63.9829 163.931 64.1459 160.063 63.9759 158.02L63.5719 158.053ZM62.5649 174.864C62.3869 175.576 62.4689 176.141 62.7159 176.538C62.9639 176.935 63.3669 177.14 63.7739 177.14V176.735C63.5059 176.735 63.2329 176.602 63.0599 176.324C62.8859 176.045 62.7989 175.599 62.9579 174.962L62.5649 174.864ZM63.7739 177.14C63.8759 177.14 64.0159 177.135 64.1699 177.071C64.3249 177.007 64.4789 176.891 64.6279 176.696C64.9189 176.315 65.2079 175.613 65.4789 174.32C66.0219 171.726 66.5079 166.646 66.6769 156.689L66.2719 156.682C66.1029 166.638 65.6169 171.684 65.0829 174.237C64.8149 175.518 64.5399 176.145 64.3069 176.45C64.1939 176.598 64.0949 176.664 64.0169 176.696C63.9369 176.729 63.8619 176.734 63.7749 176.734V177.139L63.7739 177.14ZM66.6769 156.689C66.6959 155.558 67.0949 154.95 67.5759 154.614C68.0689 154.27 68.6849 154.188 69.1749 154.188V153.783C68.6519 153.783 67.9379 153.868 67.3439 154.282C66.7379 154.705 66.2929 155.445 66.2719 156.682L66.6769 156.689ZM69.2599 153.802C68.1259 153.273 65.9079 152.668 63.5779 153.011L63.6369 153.412C65.8719 153.083 68.0099 153.666 69.0879 154.169L69.2599 153.802ZM62.0879 155.151C62.7959 155.584 63.4389 156.453 63.5719 158.053L63.9759 158.02C63.8339 156.316 63.1369 155.318 62.2999 154.806L62.0879 155.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1937 156.117L62.2767 156.124C61.7497 156.032 61.7497 155.435 61.7487 155.124L62.0417 151.337C60.0617 149.777 60.2977 149.893 59.3857 147.619L59.7037 144.592C61.5037 142.567 59.9357 143.1 63.2747 141.518L63.5327 139.109C63.8667 135.886 64.1137 133.022 64.1137 131.496C64.1137 126.771 63.4367 117.658 63.1017 115.97C62.8337 114.62 63.9797 113.945 64.7897 114.957C65.9737 116.437 67.4157 130.204 66.3637 141.517C68.6127 142.484 70.1877 144.039 70.1877 146.684C70.1877 146.684 69.9077 152.396 64.1127 152.043C64.0587 152.04 64.0117 152.205 64.0007 152.36C63.9787 152.657 63.8727 153.108 63.6737 153.67L63.4977 154.845C63.2247 155.326 63.0997 155.573 62.9157 155.848C62.8847 155.943 62.8907 155.959 62.7507 156.012C62.4777 156.116 62.4237 156.136 62.2767 156.124",
    fill: "url(#paint2_linear_59_24288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0987 141.554C60.9427 142.263 59.3857 144.292 59.3857 146.685C59.3857 148.665 60.4517 150.397 62.0417 151.337M66.3627 141.519C68.5767 142.193 70.1867 144.251 70.1867 146.686C70.1867 149.669 67.7687 152.086 64.7867 152.086C64.5577 152.086 64.3327 152.072 64.1117 152.044",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.139 148.71C65.464 149.273 64.519 149.723 64.114 151.748C63.9 152.818 63.437 156.136 62.425 156.136C61.75 156.136 61.75 155.461 61.75 155.123C61.75 153.773 64.114 136.222 64.114 131.497C64.114 126.772 63.437 117.659 63.102 115.971C62.834 114.621 63.98 113.946 64.79 114.958C66.14 116.646 67.49 130.822 66.14 143.647",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0578 142.569C75.0578 142.095 74.6737 141.711 74.1998 141.711C73.7259 141.711 73.3418 142.095 73.3418 142.569V151.036C73.3418 151.51 73.7259 151.894 74.1998 151.894C74.6737 151.894 75.0578 151.51 75.0578 151.036V142.569Z",
    fill: "url(#paint3_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 127.323V127.23H0.5V164.381H35.229V164.288",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0185 127.323C86.9205 117.81 76.2625 111.5 64.1245 111.5C51.9865 111.5 41.3275 117.81 35.2305 127.323V164.287C41.3285 173.8 51.9865 180.11 64.1245 180.11C76.2625 180.11 86.9215 173.8 93.0185 164.287",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0176 164.288V164.381H110.383V127.23H93.0176V127.323",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 127.323L0.5 139.846",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 164.28L0.5 151.758",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 145.567H35.229",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.5 107H368.5V118L372.75 119V121.5L348 121L342.5 117.5L337.5 125.5L344.5 129.5H336.5H328V151.5H332.5V181H341C341 185 341 187.5 346.5 187.5H392.5V182H412V164H419.5V133H423.5V129.5C423.5 123.9 419.167 122.5 417 122.5H391.5V126.5H387L381.25 121.5V119L385.5 118V107Z",
    fill: "url(#paint4_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.5 165C346.5 164.448 346.948 164 347.5 164H350.5C351.052 164 351.5 164.448 351.5 165V170C351.5 170.552 351.052 171 350.5 171H347.5C346.948 171 346.5 170.552 346.5 170V165Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M354.5 165C354.5 164.448 354.948 164 355.5 164H358.5C359.052 164 359.5 164.448 359.5 165V170C359.5 170.552 359.052 171 358.5 171H355.5C354.948 171 354.5 170.552 354.5 170V165Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 165C362.5 164.448 362.948 164 363.5 164H366.5C367.052 164 367.5 164.448 367.5 165V170C367.5 170.552 367.052 171 366.5 171H363.5C362.948 171 362.5 170.552 362.5 170V165Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M370.5 165C370.5 164.448 370.948 164 371.5 164H374.5C375.052 164 375.5 164.448 375.5 165V170C375.5 170.552 375.052 171 374.5 171H371.5C370.948 171 370.5 170.552 370.5 170V165Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M378.5 165C378.5 164.448 378.948 164 379.5 164H382.5C383.052 164 383.5 164.448 383.5 165V170C383.5 170.552 383.052 171 382.5 171H379.5C378.948 171 378.5 170.552 378.5 170V165Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M346.5 142C346.5 141.448 346.948 141 347.5 141H350.5C351.052 141 351.5 141.448 351.5 142V149C351.5 149.552 351.052 150 350.5 150H347.5C346.948 150 346.5 149.552 346.5 149V142Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5 142C353.5 141.448 353.948 141 354.5 141H357.5C358.052 141 358.5 141.448 358.5 142V149C358.5 149.552 358.052 150 357.5 150H354.5C353.948 150 353.5 149.552 353.5 149V142Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 142C360.5 141.448 360.948 141 361.5 141H364.5C365.052 141 365.5 141.448 365.5 142V149C365.5 149.552 365.052 150 364.5 150H361.5C360.948 150 360.5 149.552 360.5 149V142Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M367.5 142C367.5 141.448 367.948 141 368.5 141H371.5C372.052 141 372.5 141.448 372.5 142V149C372.5 149.552 372.052 150 371.5 150H368.5C367.948 150 367.5 149.552 367.5 149V142Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 142C374.5 141.448 374.948 141 375.5 141H378.5C379.052 141 379.5 141.448 379.5 142V149C379.5 149.552 379.052 150 378.5 150H375.5C374.948 150 374.5 149.552 374.5 149V142Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 142C381.5 141.448 381.948 141 382.5 141H385.5C386.052 141 386.5 141.448 386.5 142V149C386.5 149.552 386.052 150 385.5 150H382.5C381.948 150 381.5 149.552 381.5 149V142Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M349.5 159V153H345.5V159M357.5 159V153H353.5V159M365.5 159V153H361.5V159M373.5 159V153H369.5V159M381.5 159V153H377.5V159M389.5 162V153H385.5V159",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5 129.5H343.5V151.5H332",
    stroke: "black",
    strokeWidth: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 151.5V156.5C337.5 157.333 338.1 159 340.5 159H343V164H339.5C337 164 332.5 162.3 332.5 157.5V151.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 137H389H391.5H407V129H391.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5 164H418.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5 159H345.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M349.5 159H353.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5 159H361.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M365.5 159H369.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M373.5 159H377.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 159H385.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 174H412",
    stroke: "black",
    strokeWidth: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M366.5 174V187.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M369.5 174V187.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M391.5 126V152C391.5 153.657 392.843 155 394.5 155H419.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 407.5,
    cy: 169.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M415.5 122.5V155",
    stroke: "black",
    strokeWidth: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 129.5H359.5V137",
    stroke: "black",
    strokeWidth: 0.6
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 129.5H367.75C369.821 129.5 371.5 131.179 371.5 133.25V133.25C371.5 135.321 369.821 137 367.75 137H359.5V129.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M391.5 152.5L389 164",
    stroke: "black",
    strokeWidth: 0.6
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 164L400.5 155V142.5H391.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M677 499L677 43L683 43L683 499L677 499Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M617 111H677V117H617V111Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M584.5 74H567.5V85L571.75 86V88.5L547 88L541.5 84.5L536.5 92.5L543.5 96.5H535.5H527V118.5H531.5V148H540C540 152 540 154.5 545.5 154.5H591.5V149H611V131H618.5V100H622.5V96.5C622.5 90.9 618.167 89.5 616 89.5H590.5V93.5H586L580.25 88.5V86L584.5 85V74Z",
    fill: "url(#paint5_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 132C545.5 131.448 545.948 131 546.5 131H549.5C550.052 131 550.5 131.448 550.5 132V137C550.5 137.552 550.052 138 549.5 138H546.5C545.948 138 545.5 137.552 545.5 137V132Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5 132C553.5 131.448 553.948 131 554.5 131H557.5C558.052 131 558.5 131.448 558.5 132V137C558.5 137.552 558.052 138 557.5 138H554.5C553.948 138 553.5 137.552 553.5 137V132Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M561.5 132C561.5 131.448 561.948 131 562.5 131H565.5C566.052 131 566.5 131.448 566.5 132V137C566.5 137.552 566.052 138 565.5 138H562.5C561.948 138 561.5 137.552 561.5 137V132Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 132C569.5 131.448 569.948 131 570.5 131H573.5C574.052 131 574.5 131.448 574.5 132V137C574.5 137.552 574.052 138 573.5 138H570.5C569.948 138 569.5 137.552 569.5 137V132Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M577.5 132C577.5 131.448 577.948 131 578.5 131H581.5C582.052 131 582.5 131.448 582.5 132V137C582.5 137.552 582.052 138 581.5 138H578.5C577.948 138 577.5 137.552 577.5 137V132Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 109C545.5 108.448 545.948 108 546.5 108H549.5C550.052 108 550.5 108.448 550.5 109V116C550.5 116.552 550.052 117 549.5 117H546.5C545.948 117 545.5 116.552 545.5 116V109Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5 109C552.5 108.448 552.948 108 553.5 108H556.5C557.052 108 557.5 108.448 557.5 109V116C557.5 116.552 557.052 117 556.5 117H553.5C552.948 117 552.5 116.552 552.5 116V109Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 109C559.5 108.448 559.948 108 560.5 108H563.5C564.052 108 564.5 108.448 564.5 109V116C564.5 116.552 564.052 117 563.5 117H560.5C559.948 117 559.5 116.552 559.5 116V109Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M566.5 109C566.5 108.448 566.948 108 567.5 108H570.5C571.052 108 571.5 108.448 571.5 109V116C571.5 116.552 571.052 117 570.5 117H567.5C566.948 117 566.5 116.552 566.5 116V109Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 109C573.5 108.448 573.948 108 574.5 108H577.5C578.052 108 578.5 108.448 578.5 109V116C578.5 116.552 578.052 117 577.5 117H574.5C573.948 117 573.5 116.552 573.5 116V109Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 109C580.5 108.448 580.948 108 581.5 108H584.5C585.052 108 585.5 108.448 585.5 109V116C585.5 116.552 585.052 117 584.5 117H581.5C580.948 117 580.5 116.552 580.5 116V109Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 126V120H544.5V126M556.5 126V120H552.5V126M564.5 126V120H560.5V126M572.5 126V120H568.5V126M580.5 126V120H576.5V126M588.5 129V120H584.5V126",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5 96.5H542.5V118.5H531",
    stroke: "black",
    strokeWidth: 0.6
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 118.5V123.5C536.5 124.333 537.1 126 539.5 126H542V131H538.5C536 131 531.5 129.3 531.5 124.5V118.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 104H588H590.5H606V96H590.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 131H617.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 126H544.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 126H552.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M556.5 126H560.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5 126H568.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5 126H576.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 126H584.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M531.5 141H611",
    stroke: "black",
    strokeWidth: 0.6
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M565.5 141V154.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5 141V154.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 93V119C590.5 120.657 591.843 122 593.5 122H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.5,
    cy: 136.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M614.5 89.5V122",
    stroke: "black",
    strokeWidth: 0.6
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 96.5H558.5V104",
    stroke: "black",
    strokeWidth: 0.6
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 96.5H566.75C568.821 96.5 570.5 98.1789 570.5 100.25V100.25C570.5 102.321 568.821 104 566.75 104H558.5V96.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 119.5L588 131",
    stroke: "black",
    strokeWidth: 0.6
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M597.5 131L599.5 122V109.5H590.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M617 267H677V273H617V267Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M584.5 230H567.5V241L571.75 242V244.5L547 244L541.5 240.5L536.5 248.5L543.5 252.5H535.5H527V274.5H531.5V304H540C540 308 540 310.5 545.5 310.5H591.5V305H611V287H618.5V256H622.5V252.5C622.5 246.9 618.167 245.5 616 245.5H590.5V249.5H586L580.25 244.5V242L584.5 241V230Z",
    fill: "url(#paint6_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 288C545.5 287.448 545.948 287 546.5 287H549.5C550.052 287 550.5 287.448 550.5 288V293C550.5 293.552 550.052 294 549.5 294H546.5C545.948 294 545.5 293.552 545.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5 288C553.5 287.448 553.948 287 554.5 287H557.5C558.052 287 558.5 287.448 558.5 288V293C558.5 293.552 558.052 294 557.5 294H554.5C553.948 294 553.5 293.552 553.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M561.5 288C561.5 287.448 561.948 287 562.5 287H565.5C566.052 287 566.5 287.448 566.5 288V293C566.5 293.552 566.052 294 565.5 294H562.5C561.948 294 561.5 293.552 561.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 288C569.5 287.448 569.948 287 570.5 287H573.5C574.052 287 574.5 287.448 574.5 288V293C574.5 293.552 574.052 294 573.5 294H570.5C569.948 294 569.5 293.552 569.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M577.5 288C577.5 287.448 577.948 287 578.5 287H581.5C582.052 287 582.5 287.448 582.5 288V293C582.5 293.552 582.052 294 581.5 294H578.5C577.948 294 577.5 293.552 577.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 265C545.5 264.448 545.948 264 546.5 264H549.5C550.052 264 550.5 264.448 550.5 265V272C550.5 272.552 550.052 273 549.5 273H546.5C545.948 273 545.5 272.552 545.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5 265C552.5 264.448 552.948 264 553.5 264H556.5C557.052 264 557.5 264.448 557.5 265V272C557.5 272.552 557.052 273 556.5 273H553.5C552.948 273 552.5 272.552 552.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 265C559.5 264.448 559.948 264 560.5 264H563.5C564.052 264 564.5 264.448 564.5 265V272C564.5 272.552 564.052 273 563.5 273H560.5C559.948 273 559.5 272.552 559.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M566.5 265C566.5 264.448 566.948 264 567.5 264H570.5C571.052 264 571.5 264.448 571.5 265V272C571.5 272.552 571.052 273 570.5 273H567.5C566.948 273 566.5 272.552 566.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 265C573.5 264.448 573.948 264 574.5 264H577.5C578.052 264 578.5 264.448 578.5 265V272C578.5 272.552 578.052 273 577.5 273H574.5C573.948 273 573.5 272.552 573.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 265C580.5 264.448 580.948 264 581.5 264H584.5C585.052 264 585.5 264.448 585.5 265V272C585.5 272.552 585.052 273 584.5 273H581.5C580.948 273 580.5 272.552 580.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 282V276H544.5V282M556.5 282V276H552.5V282M564.5 282V276H560.5V282M572.5 282V276H568.5V282M580.5 282V276H576.5V282M588.5 285V276H584.5V282",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5 252.5H542.5V274.5H531",
    stroke: "black",
    strokeWidth: 0.6
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 274.5V279.5C536.5 280.333 537.1 282 539.5 282H542V287H538.5C536 287 531.5 285.3 531.5 280.5V274.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 260H588H590.5H606V252H590.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 287H617.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 282H544.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 282H552.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M556.5 282H560.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5 282H568.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5 282H576.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 282H584.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M531.5 297H611",
    stroke: "black",
    strokeWidth: 0.6
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M565.5 297V310.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5 297V310.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 249V275C590.5 276.657 591.843 278 593.5 278H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.5,
    cy: 292.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M614.5 245.5V278",
    stroke: "black",
    strokeWidth: 0.6
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 252.5H558.5V260",
    stroke: "black",
    strokeWidth: 0.6
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 252.5H566.75C568.821 252.5 570.5 254.179 570.5 256.25V256.25C570.5 258.321 568.821 260 566.75 260H558.5V252.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 275.5L588 287",
    stroke: "black",
    strokeWidth: 0.6
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M597.5 287L599.5 278V265.5H590.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M617 424H677V430H617V424Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M584.5 387H567.5V398L571.75 399V401.5L547 401L541.5 397.5L536.5 405.5L543.5 409.5H535.5H527V431.5H531.5V461H540C540 465 540 467.5 545.5 467.5H591.5V462H611V444H618.5V413H622.5V409.5C622.5 403.9 618.167 402.5 616 402.5H590.5V406.5H586L580.25 401.5V399L584.5 398V387Z",
    fill: "url(#paint7_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 445C545.5 444.448 545.948 444 546.5 444H549.5C550.052 444 550.5 444.448 550.5 445V450C550.5 450.552 550.052 451 549.5 451H546.5C545.948 451 545.5 450.552 545.5 450V445Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5 445C553.5 444.448 553.948 444 554.5 444H557.5C558.052 444 558.5 444.448 558.5 445V450C558.5 450.552 558.052 451 557.5 451H554.5C553.948 451 553.5 450.552 553.5 450V445Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M561.5 445C561.5 444.448 561.948 444 562.5 444H565.5C566.052 444 566.5 444.448 566.5 445V450C566.5 450.552 566.052 451 565.5 451H562.5C561.948 451 561.5 450.552 561.5 450V445Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 445C569.5 444.448 569.948 444 570.5 444H573.5C574.052 444 574.5 444.448 574.5 445V450C574.5 450.552 574.052 451 573.5 451H570.5C569.948 451 569.5 450.552 569.5 450V445Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M577.5 445C577.5 444.448 577.948 444 578.5 444H581.5C582.052 444 582.5 444.448 582.5 445V450C582.5 450.552 582.052 451 581.5 451H578.5C577.948 451 577.5 450.552 577.5 450V445Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5 422C545.5 421.448 545.948 421 546.5 421H549.5C550.052 421 550.5 421.448 550.5 422V429C550.5 429.552 550.052 430 549.5 430H546.5C545.948 430 545.5 429.552 545.5 429V422Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5 422C552.5 421.448 552.948 421 553.5 421H556.5C557.052 421 557.5 421.448 557.5 422V429C557.5 429.552 557.052 430 556.5 430H553.5C552.948 430 552.5 429.552 552.5 429V422Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 422C559.5 421.448 559.948 421 560.5 421H563.5C564.052 421 564.5 421.448 564.5 422V429C564.5 429.552 564.052 430 563.5 430H560.5C559.948 430 559.5 429.552 559.5 429V422Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M566.5 422C566.5 421.448 566.948 421 567.5 421H570.5C571.052 421 571.5 421.448 571.5 422V429C571.5 429.552 571.052 430 570.5 430H567.5C566.948 430 566.5 429.552 566.5 429V422Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M573.5 422C573.5 421.448 573.948 421 574.5 421H577.5C578.052 421 578.5 421.448 578.5 422V429C578.5 429.552 578.052 430 577.5 430H574.5C573.948 430 573.5 429.552 573.5 429V422Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 422C580.5 421.448 580.948 421 581.5 421H584.5C585.052 421 585.5 421.448 585.5 422V429C585.5 429.552 585.052 430 584.5 430H581.5C580.948 430 580.5 429.552 580.5 429V422Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 439V433H544.5V439M556.5 439V433H552.5V439M564.5 439V433H560.5V439M572.5 439V433H568.5V439M580.5 439V433H576.5V439M588.5 442V433H584.5V439",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M535.5 409.5H542.5V431.5H531",
    stroke: "black",
    strokeWidth: 0.6
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 431.5V436.5C536.5 437.333 537.1 439 539.5 439H542V444H538.5C536 444 531.5 442.3 531.5 437.5V431.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 417H588H590.5H606V409H590.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 444H617.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M541.5 439H544.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 439H552.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M556.5 439H560.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M564.5 439H568.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M572.5 439H576.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 439H584.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M531.5 454H611",
    stroke: "black",
    strokeWidth: 0.6
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M565.5 454V467.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M568.5 454V467.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 406V432C590.5 433.657 591.843 435 593.5 435H618.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.5,
    cy: 449.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M614.5 402.5V435",
    stroke: "black",
    strokeWidth: 0.6
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 409.5H558.5V417",
    stroke: "black",
    strokeWidth: 0.6
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M558.5 409.5H566.75C568.821 409.5 570.5 411.179 570.5 413.25V413.25C570.5 415.321 568.821 417 566.75 417H558.5V409.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M590.5 432.5L588 444",
    stroke: "black",
    strokeWidth: 0.6
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M597.5 444L599.5 435V422.5H590.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.25 209.507L761 191.754L733.25 174V189.254H683V195.254H733.25V209.507Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M733.25 366.507L761 348.754L733.25 331V346.254H683V352.254H733.25V366.507Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M75 266H177V272H75V266Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 230H217.5V241L221.75 242V244.5L197 244L191.5 240.5L186.5 248.5L193.5 252.5H185.5H177V274.5H181.5V304H190C190 308 190 310.5 195.5 310.5H241.5V305H261V287H268.5V256H272.5V252.5C272.5 246.9 268.167 245.5 266 245.5H240.5V249.5H236L230.25 244.5V242L234.5 241V230Z",
    fill: "url(#paint8_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 288C195.5 287.448 195.948 287 196.5 287H199.5C200.052 287 200.5 287.448 200.5 288V293C200.5 293.552 200.052 294 199.5 294H196.5C195.948 294 195.5 293.552 195.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M203.5 288C203.5 287.448 203.948 287 204.5 287H207.5C208.052 287 208.5 287.448 208.5 288V293C208.5 293.552 208.052 294 207.5 294H204.5C203.948 294 203.5 293.552 203.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 288C211.5 287.448 211.948 287 212.5 287H215.5C216.052 287 216.5 287.448 216.5 288V293C216.5 293.552 216.052 294 215.5 294H212.5C211.948 294 211.5 293.552 211.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M219.5 288C219.5 287.448 219.948 287 220.5 287H223.5C224.052 287 224.5 287.448 224.5 288V293C224.5 293.552 224.052 294 223.5 294H220.5C219.948 294 219.5 293.552 219.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 288C227.5 287.448 227.948 287 228.5 287H231.5C232.052 287 232.5 287.448 232.5 288V293C232.5 293.552 232.052 294 231.5 294H228.5C227.948 294 227.5 293.552 227.5 293V288Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M195.5 265C195.5 264.448 195.948 264 196.5 264H199.5C200.052 264 200.5 264.448 200.5 265V272C200.5 272.552 200.052 273 199.5 273H196.5C195.948 273 195.5 272.552 195.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 265C202.5 264.448 202.948 264 203.5 264H206.5C207.052 264 207.5 264.448 207.5 265V272C207.5 272.552 207.052 273 206.5 273H203.5C202.948 273 202.5 272.552 202.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M209.5 265C209.5 264.448 209.948 264 210.5 264H213.5C214.052 264 214.5 264.448 214.5 265V272C214.5 272.552 214.052 273 213.5 273H210.5C209.948 273 209.5 272.552 209.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5 265C216.5 264.448 216.948 264 217.5 264H220.5C221.052 264 221.5 264.448 221.5 265V272C221.5 272.552 221.052 273 220.5 273H217.5C216.948 273 216.5 272.552 216.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 265C223.5 264.448 223.948 264 224.5 264H227.5C228.052 264 228.5 264.448 228.5 265V272C228.5 272.552 228.052 273 227.5 273H224.5C223.948 273 223.5 272.552 223.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 265C230.5 264.448 230.948 264 231.5 264H234.5C235.052 264 235.5 264.448 235.5 265V272C235.5 272.552 235.052 273 234.5 273H231.5C230.948 273 230.5 272.552 230.5 272V265Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 282V276H194.5V282M206.5 282V276H202.5V282M214.5 282V276H210.5V282M222.5 282V276H218.5V282M230.5 282V276H226.5V282M238.5 285V276H234.5V282",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M185.5 252.5H192.5V274.5H181",
    stroke: "black",
    strokeWidth: 0.6
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M186.5 274.5V279.5C186.5 280.333 187.1 282 189.5 282H192V287H188.5C186 287 181.5 285.3 181.5 280.5V274.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 260H238H240.5H256V252H240.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 287H267.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 282H194.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 282H202.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 282H210.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 282H218.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 282H226.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 282H234.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 297H261",
    stroke: "black",
    strokeWidth: 0.6
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 297V310.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5 297V310.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 249V275C240.5 276.657 241.843 278 243.5 278H268.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 292.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M264.5 245.5V278",
    stroke: "black",
    strokeWidth: 0.6
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 252.5H208.5V260",
    stroke: "black",
    strokeWidth: 0.6
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M208.5 252.5H216.75C218.821 252.5 220.5 254.179 220.5 256.25V256.25C220.5 258.321 218.821 260 216.75 260H208.5V252.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 275.5L238 287",
    stroke: "black",
    strokeWidth: 0.6
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M247.5 287L249.5 278V265.5H240.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_59_24288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9835 260.758H60.8205C57.8205 260.758 53.1895 264.359 53.1895 268.802C53.1895 273.245 57.8205 276.846 60.8205 276.846H65.9835C68.6815 276.846 71.2915 275.42 73.3425 272.824V264.78C71.2915 262.184 68.6815 260.758 65.9835 260.758Z",
    fill: "url(#paint9_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0613 276.001H69.2603C68.4853 275.783 66.6003 276.335 66.5603 278.702C66.2223 298.615 64.6153 298.953 63.8603 298.953C63.1853 298.953 62.5103 298.277 62.8473 296.928C63.2133 295.464 64.1973 284.102 63.8603 280.052C63.7223 278.4 63.0523 277.467 62.2803 276.995L62.3633 277.002C62.9033 276.807 63.6373 275.413 63.7353 275.162H66.8203",
    fill: "url(#paint10_linear_59_24288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1739 275.986V276.189C69.2689 276.189 69.3509 276.123 69.3719 276.03C69.3929 275.937 69.3459 275.843 69.2599 275.803L69.1739 275.986ZM63.5719 280.053C63.7389 282.06 63.5789 285.898 63.3289 289.43C63.2039 291.193 63.0579 292.875 62.9199 294.207C62.7809 295.546 62.6519 296.515 62.5649 296.864L62.9579 296.962C63.0539 296.579 63.1849 295.578 63.3229 294.249C63.4619 292.912 63.6089 291.226 63.7339 289.459C63.9829 285.931 64.1459 282.063 63.9759 280.02L63.5719 280.053ZM62.5649 296.864C62.3869 297.576 62.4689 298.141 62.7159 298.538C62.9639 298.935 63.3669 299.14 63.7739 299.14V298.735C63.5059 298.735 63.2329 298.602 63.0599 298.324C62.8859 298.045 62.7989 297.599 62.9579 296.962L62.5649 296.864ZM63.7739 299.14C63.8759 299.14 64.0159 299.135 64.1699 299.071C64.3249 299.007 64.4789 298.891 64.6279 298.696C64.9189 298.315 65.2079 297.613 65.4789 296.32C66.0219 293.726 66.5079 288.646 66.6769 278.689L66.2719 278.682C66.1029 288.638 65.6169 293.684 65.0829 296.237C64.8149 297.518 64.5399 298.145 64.3069 298.45C64.1939 298.598 64.0949 298.664 64.0169 298.696C63.9369 298.729 63.8619 298.734 63.7749 298.734V299.139L63.7739 299.14ZM66.6769 278.689C66.6959 277.558 67.0949 276.95 67.5759 276.614C68.0689 276.27 68.6849 276.188 69.1749 276.188V275.783C68.6519 275.783 67.9379 275.868 67.3439 276.282C66.7379 276.705 66.2929 277.445 66.2719 278.682L66.6769 278.689ZM69.2599 275.802C68.1259 275.273 65.9079 274.668 63.5779 275.011L63.6369 275.412C65.8719 275.083 68.0099 275.666 69.0879 276.169L69.2599 275.802ZM62.0879 277.151C62.7959 277.584 63.4389 278.453 63.5719 280.053L63.9759 280.02C63.8339 278.316 63.1369 277.318 62.2999 276.806L62.0879 277.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1937 278.117L62.2767 278.124C61.7497 278.032 61.7497 277.435 61.7487 277.124L62.0417 273.337C60.0617 271.777 60.2977 271.893 59.3857 269.619L59.7037 266.592C61.5037 264.567 59.9357 265.1 63.2747 263.518L63.5327 261.109C63.8667 257.886 64.1137 255.022 64.1137 253.496C64.1137 248.771 63.4367 239.658 63.1017 237.97C62.8337 236.62 63.9797 235.945 64.7897 236.957C65.9737 238.437 67.4157 252.204 66.3637 263.517C68.6127 264.484 70.1877 266.039 70.1877 268.684C70.1877 268.684 69.9077 274.396 64.1127 274.043C64.0587 274.04 64.0117 274.205 64.0007 274.36C63.9787 274.657 63.8727 275.108 63.6737 275.67L63.4977 276.845C63.2247 277.326 63.0997 277.573 62.9157 277.848C62.8847 277.943 62.8907 277.959 62.7507 278.012C62.4777 278.116 62.4237 278.136 62.2767 278.124",
    fill: "url(#paint11_linear_59_24288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0987 263.554C60.9427 264.263 59.3857 266.292 59.3857 268.685C59.3857 270.665 60.4517 272.397 62.0417 273.337M66.3627 263.519C68.5767 264.193 70.1867 266.251 70.1867 268.686C70.1867 271.669 67.7687 274.086 64.7867 274.086C64.5577 274.086 64.3327 274.072 64.1117 274.044",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.139 270.71C65.464 271.273 64.519 271.723 64.114 273.748C63.9 274.818 63.437 278.136 62.425 278.136C61.75 278.136 61.75 277.461 61.75 277.123C61.75 275.773 64.114 258.222 64.114 253.497C64.114 248.772 63.437 239.659 63.102 237.971C62.834 236.621 63.98 235.946 64.79 236.958C66.14 238.646 67.49 252.822 66.14 265.647",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0578 264.569C75.0578 264.095 74.6737 263.711 74.1998 263.711C73.7259 263.711 73.3418 264.095 73.3418 264.569V273.036C73.3418 273.51 73.7259 273.894 74.1998 273.894C74.6737 273.894 75.0578 273.51 75.0578 273.036V264.569Z",
    fill: "url(#paint12_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 249.323V249.23H0.5V286.381H35.229V286.288",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0185 249.323C86.9205 239.81 76.2625 233.5 64.1245 233.5C51.9865 233.5 41.3275 239.81 35.2305 249.323V286.287C41.3285 295.8 51.9865 302.11 64.1245 302.11C76.2625 302.11 86.9215 295.8 93.0185 286.287",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0176 286.288V286.381H110.383V249.23H93.0176V249.323",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 249.323L0.5 261.846",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 286.28L0.5 273.758",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 267.567H35.229",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M75 391H328V397H75V391Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M385.5 353H368.5V364L372.75 365V367.5L348 367L342.5 363.5L337.5 371.5L344.5 375.5H336.5H328V397.5H332.5V427H341C341 431 341 433.5 346.5 433.5H392.5V428H412V410H419.5V379H423.5V375.5C423.5 369.9 419.167 368.5 417 368.5H391.5V372.5H387L381.25 367.5V365L385.5 364V353Z",
    fill: "url(#paint13_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.6
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M346.5 411C346.5 410.448 346.948 410 347.5 410H350.5C351.052 410 351.5 410.448 351.5 411V416C351.5 416.552 351.052 417 350.5 417H347.5C346.948 417 346.5 416.552 346.5 416V411Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M354.5 411C354.5 410.448 354.948 410 355.5 410H358.5C359.052 410 359.5 410.448 359.5 411V416C359.5 416.552 359.052 417 358.5 417H355.5C354.948 417 354.5 416.552 354.5 416V411Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M362.5 411C362.5 410.448 362.948 410 363.5 410H366.5C367.052 410 367.5 410.448 367.5 411V416C367.5 416.552 367.052 417 366.5 417H363.5C362.948 417 362.5 416.552 362.5 416V411Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M370.5 411C370.5 410.448 370.948 410 371.5 410H374.5C375.052 410 375.5 410.448 375.5 411V416C375.5 416.552 375.052 417 374.5 417H371.5C370.948 417 370.5 416.552 370.5 416V411Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M378.5 411C378.5 410.448 378.948 410 379.5 410H382.5C383.052 410 383.5 410.448 383.5 411V416C383.5 416.552 383.052 417 382.5 417H379.5C378.948 417 378.5 416.552 378.5 416V411Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M346.5 388C346.5 387.448 346.948 387 347.5 387H350.5C351.052 387 351.5 387.448 351.5 388V395C351.5 395.552 351.052 396 350.5 396H347.5C346.948 396 346.5 395.552 346.5 395V388Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M353.5 388C353.5 387.448 353.948 387 354.5 387H357.5C358.052 387 358.5 387.448 358.5 388V395C358.5 395.552 358.052 396 357.5 396H354.5C353.948 396 353.5 395.552 353.5 395V388Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M360.5 388C360.5 387.448 360.948 387 361.5 387H364.5C365.052 387 365.5 387.448 365.5 388V395C365.5 395.552 365.052 396 364.5 396H361.5C360.948 396 360.5 395.552 360.5 395V388Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M367.5 388C367.5 387.448 367.948 387 368.5 387H371.5C372.052 387 372.5 387.448 372.5 388V395C372.5 395.552 372.052 396 371.5 396H368.5C367.948 396 367.5 395.552 367.5 395V388Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M374.5 388C374.5 387.448 374.948 387 375.5 387H378.5C379.052 387 379.5 387.448 379.5 388V395C379.5 395.552 379.052 396 378.5 396H375.5C374.948 396 374.5 395.552 374.5 395V388Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 388C381.5 387.448 381.948 387 382.5 387H385.5C386.052 387 386.5 387.448 386.5 388V395C386.5 395.552 386.052 396 385.5 396H382.5C381.948 396 381.5 395.552 381.5 395V388Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M349.5 405V399H345.5V405M357.5 405V399H353.5V405M365.5 405V399H361.5V405M373.5 405V399H369.5V405M381.5 405V399H377.5V405M389.5 408V399H385.5V405",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M336.5 375.5H343.5V397.5H332",
    stroke: "black",
    strokeWidth: 0.6
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 397.5V402.5C337.5 403.333 338.1 405 340.5 405H343V410H339.5C337 410 332.5 408.3 332.5 403.5V397.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 383H389H391.5H407V375H391.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5 410H418.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5 405H345.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M349.5 405H353.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M357.5 405H361.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M365.5 405H369.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M373.5 405H377.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M381.5 405H385.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5 420H412",
    stroke: "black",
    strokeWidth: 0.6
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M366.5 420V433.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M369.5 420V433.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M391.5 372V398C391.5 399.657 392.843 401 394.5 401H419.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.5,
    cy: 415.5,
    r: 2,
    stroke: "black",
    strokeWidth: 0.6
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M415.5 368.5V401",
    stroke: "black",
    strokeWidth: 0.6
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 375.5H359.5V383",
    stroke: "black",
    strokeWidth: 0.6
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 375.5H367.75C369.821 375.5 371.5 377.179 371.5 379.25V379.25C371.5 381.321 369.821 383 367.75 383H359.5V375.5Z",
    stroke: "black",
    strokeWidth: 0.6
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M391.5 398.5L389 410",
    stroke: "black",
    strokeWidth: 0.6
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 410L400.5 401V388.5H391.5",
    stroke: "black",
    strokeWidth: 0.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_59_24288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9835 385.758H60.8205C57.8205 385.758 53.1895 389.359 53.1895 393.802C53.1895 398.245 57.8205 401.846 60.8205 401.846H65.9835C68.6815 401.846 71.2915 400.42 73.3425 397.824V389.78C71.2915 387.184 68.6815 385.758 65.9835 385.758Z",
    fill: "url(#paint14_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0613 401.001H69.2603C68.4853 400.783 66.6003 401.335 66.5603 403.702C66.2223 423.615 64.6153 423.953 63.8603 423.953C63.1853 423.953 62.5103 423.277 62.8473 421.928C63.2133 420.464 64.1973 409.102 63.8603 405.052C63.7223 403.4 63.0523 402.467 62.2803 401.995L62.3633 402.002C62.9033 401.807 63.6373 400.413 63.7353 400.162H66.8203",
    fill: "url(#paint15_linear_59_24288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1739 400.986V401.189C69.2689 401.189 69.3509 401.123 69.3719 401.03C69.3929 400.937 69.3459 400.843 69.2599 400.803L69.1739 400.986ZM63.5719 405.053C63.7389 407.06 63.5789 410.898 63.3289 414.43C63.2039 416.193 63.0579 417.875 62.9199 419.207C62.7809 420.546 62.6519 421.515 62.5649 421.864L62.9579 421.962C63.0539 421.579 63.1849 420.578 63.3229 419.249C63.4619 417.912 63.6089 416.226 63.7339 414.459C63.9829 410.931 64.1459 407.063 63.9759 405.02L63.5719 405.053ZM62.5649 421.864C62.3869 422.576 62.4689 423.141 62.7159 423.538C62.9639 423.935 63.3669 424.14 63.7739 424.14V423.735C63.5059 423.735 63.2329 423.602 63.0599 423.324C62.8859 423.045 62.7989 422.599 62.9579 421.962L62.5649 421.864ZM63.7739 424.14C63.8759 424.14 64.0159 424.135 64.1699 424.071C64.3249 424.007 64.4789 423.891 64.6279 423.696C64.9189 423.315 65.2079 422.613 65.4789 421.32C66.0219 418.726 66.5079 413.646 66.6769 403.689L66.2719 403.682C66.1029 413.638 65.6169 418.684 65.0829 421.237C64.8149 422.518 64.5399 423.145 64.3069 423.45C64.1939 423.598 64.0949 423.664 64.0169 423.696C63.9369 423.729 63.8619 423.734 63.7749 423.734V424.139L63.7739 424.14ZM66.6769 403.689C66.6959 402.558 67.0949 401.95 67.5759 401.614C68.0689 401.27 68.6849 401.188 69.1749 401.188V400.783C68.6519 400.783 67.9379 400.868 67.3439 401.282C66.7379 401.705 66.2929 402.445 66.2719 403.682L66.6769 403.689ZM69.2599 400.802C68.1259 400.273 65.9079 399.668 63.5779 400.011L63.6369 400.412C65.8719 400.083 68.0099 400.666 69.0879 401.169L69.2599 400.802ZM62.0879 402.151C62.7959 402.584 63.4389 403.453 63.5719 405.053L63.9759 405.02C63.8339 403.316 63.1369 402.318 62.2999 401.806L62.0879 402.151Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1937 403.117L62.2767 403.124C61.7497 403.032 61.7497 402.435 61.7487 402.124L62.0417 398.337C60.0617 396.777 60.2977 396.893 59.3857 394.619L59.7037 391.592C61.5037 389.567 59.9357 390.1 63.2747 388.518L63.5327 386.109C63.8667 382.886 64.1137 380.022 64.1137 378.496C64.1137 373.771 63.4367 364.658 63.1017 362.97C62.8337 361.62 63.9797 360.945 64.7897 361.957C65.9737 363.437 67.4157 377.204 66.3637 388.517C68.6127 389.484 70.1877 391.039 70.1877 393.684C70.1877 393.684 69.9077 399.396 64.1127 399.043C64.0587 399.04 64.0117 399.205 64.0007 399.36C63.9787 399.657 63.8727 400.108 63.6737 400.67L63.4977 401.845C63.2247 402.326 63.0997 402.573 62.9157 402.848C62.8847 402.943 62.8907 402.959 62.7507 403.012C62.4777 403.116 62.4237 403.136 62.2767 403.124",
    fill: "url(#paint16_linear_59_24288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0987 388.554C60.9427 389.263 59.3857 391.292 59.3857 393.685C59.3857 395.665 60.4517 397.397 62.0417 398.337M66.3627 388.519C68.5767 389.193 70.1867 391.251 70.1867 393.686C70.1867 396.669 67.7687 399.086 64.7867 399.086C64.5577 399.086 64.3327 399.072 64.1117 399.044",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.139 395.71C65.464 396.273 64.519 396.723 64.114 398.748C63.9 399.818 63.437 403.136 62.425 403.136C61.75 403.136 61.75 402.461 61.75 402.123C61.75 400.773 64.114 383.222 64.114 378.497C64.114 373.772 63.437 364.659 63.102 362.971C62.834 361.621 63.98 360.946 64.79 361.958C66.14 363.646 67.49 377.822 66.14 390.647",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0578 389.569C75.0578 389.095 74.6737 388.711 74.1998 388.711C73.7259 388.711 73.3418 389.095 73.3418 389.569V398.036C73.3418 398.51 73.7259 398.894 74.1998 398.894C74.6737 398.894 75.0578 398.51 75.0578 398.036V389.569Z",
    fill: "url(#paint17_linear_59_24288)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 374.323V374.23H0.5V411.381H35.229V411.288",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0185 374.323C86.9205 364.81 76.2625 358.5 64.1245 358.5C51.9865 358.5 41.3275 364.81 35.2305 374.323V411.287C41.3285 420.8 51.9865 427.11 64.1245 427.11C76.2625 427.11 86.9215 420.8 93.0185 411.287",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0176 411.288V411.381H110.383V374.23H93.0176V374.323",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 374.323L0.5 386.846",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.229 411.28L0.5 398.758",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 392.567H35.229",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_24288",
    x1: 53.1895,
    y1: 146.802,
    x2: 73.3425,
    y2: 146.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_24288",
    x1: 65.7703,
    y1: 153.161,
    x2: 65.7703,
    y2: 176.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_24288",
    x1: 64.7867,
    y1: 114.471,
    x2: 64.7867,
    y2: 156.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_24288",
    x1: 73.3418,
    y1: 146.802,
    x2: 75.0578,
    y2: 146.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_24288",
    x1: 375.75,
    y1: 107,
    x2: 375.75,
    y2: 187.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_24288",
    x1: 574.75,
    y1: 74,
    x2: 574.75,
    y2: 154.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_24288",
    x1: 574.75,
    y1: 230,
    x2: 574.75,
    y2: 310.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_24288",
    x1: 574.75,
    y1: 387,
    x2: 574.75,
    y2: 467.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_24288",
    x1: 224.75,
    y1: 230,
    x2: 224.75,
    y2: 310.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_24288",
    x1: 53.1895,
    y1: 268.802,
    x2: 73.3425,
    y2: 268.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_24288",
    x1: 65.7703,
    y1: 275.161,
    x2: 65.7703,
    y2: 298.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_24288",
    x1: 64.7867,
    y1: 236.471,
    x2: 64.7867,
    y2: 278.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_24288",
    x1: 73.3418,
    y1: 268.802,
    x2: 75.0578,
    y2: 268.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_24288",
    x1: 375.75,
    y1: 353,
    x2: 375.75,
    y2: 433.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_24288",
    x1: 53.1895,
    y1: 393.802,
    x2: 73.3425,
    y2: 393.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_59_24288",
    x1: 65.7703,
    y1: 400.161,
    x2: 65.7703,
    y2: 423.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_59_24288",
    x1: 64.7867,
    y1: 361.471,
    x2: 64.7867,
    y2: 403.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_59_24288",
    x1: 73.3418,
    y1: 393.802,
    x2: 75.0578,
    y2: 393.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E5F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_24288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.856,
    height: 69.611,
    fill: "white",
    transform: "translate(0 111)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_59_24288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.856,
    height: 69.611,
    fill: "white",
    transform: "translate(0 233)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_59_24288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.856,
    height: 69.611,
    fill: "white",
    transform: "translate(0 358)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSystem1000);
export default __webpack_public_path__ + "static/media/img_system_1000.a63f1664719d2568bb85d1605abd9115.svg";
export { ForwardRef as ReactComponent };